import { isVerifyPassword } from "./CheckPassword";

const USER_WIZARD_STEP_IDS = ["general", "sites", "notifications", "reports"];

export function getWizardStepIndex(stepId, stepIds = USER_WIZARD_STEP_IDS) {
  const index = stepIds.indexOf(stepId);
  return index >= 0 ? index : 0;
}

export function normalizeUserFormForDirtyCheck(data) {
  const safe = data || {};
  return {
    firstName: (safe.firstName || "").trim(),
    lastName: (safe.lastName || "").trim(),
    phone: safe.phone || "",
    email: (safe.email || "").trim().toLowerCase(),
    password: safe.password || "",
    passwordConfirm: safe.passwordConfirm || "",
    role: "owner",
    authorizedAddresses: [...(safe.authorizedAddresses || [])].sort(),
    recieveCharacterizationMail: !!safe.recieveCharacterizationMail,
    recieveCharacterizationPush: !!safe.recieveCharacterizationPush,
    recieveCharacterizationSms: !!safe.recieveCharacterizationSms,
    recieveQualicheckMail: !!safe.recieveQualicheckMail,
    recieveQualicheckPush: !!safe.recieveQualicheckPush,
    recieveQualicheckSms: !!safe.recieveQualicheckSms,
    receiveAnomalyMail: !!safe.receiveAnomalyMail,
    receiveAnomalyPush: !!safe.receiveAnomalyPush,
    receiveAnomalySms: !!safe.receiveAnomalySms,
    receiveFillingMail: !!safe.receiveFillingMail,
    receiveFillingPush: !!safe.receiveFillingPush,
    receiveFillingSms: !!safe.receiveFillingSms,
    receiveRotationMail: !!safe.receiveRotationMail,
    receiveRotationPush: !!safe.receiveRotationPush,
    receiveRotationSms: !!safe.receiveRotationSms,
    receiveDowngradeMail: !!safe.receiveDowngradeMail,
    receiveDowngradePush: !!safe.receiveDowngradePush,
    receiveDowngradeSms: !!safe.receiveDowngradeSms,
    receiveDailyPerformanceReport: !!safe.receiveDailyPerformanceReport,
  };
}

export function validateUserWizardStep(
  stepId,
  formData,
  t,
  { googleSSORequired = false, isCreate = true } = {},
) {
  if (stepId === "general") {
    const email = (formData.email || "").trim();
    if (!email) {
      return { valid: false, message: t("settingsUsers.emailRequired") };
    }
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      return {
        valid: false,
        message: t("settingsUsers.importErrorInvalidEmail"),
      };
    }

    let passwordError = "";
    const passwordValid = isVerifyPassword(
      googleSSORequired,
      formData.password,
      formData.passwordConfirm,
      (msg) => {
        passwordError = msg;
      },
      t,
      { allowEmpty: !isCreate },
    );
    if (!passwordValid) {
      return { valid: false, message: passwordError || t("An error occurred") };
    }

    return { valid: true };
  }

  return { valid: true };
}

export function validateAllUserWizardSteps(
  formData,
  t,
  { googleSSORequired = false, isCreate = true } = {},
) {
  for (const stepId of USER_WIZARD_STEP_IDS) {
    const result = validateUserWizardStep(stepId, formData, t, {
      googleSSORequired,
      isCreate,
    });
    if (!result.valid) return result;
  }
  return { valid: true };
}
